import { cx } from '@linaria/core';
import "./SegmentedControl.linaria.module.css!=!./SegmentedControl?./SegmentedControl.linaria.module.css?css=H4sIAAAAAAAAA51V246jOBB9n6/IW2akuIVJOiS0Rpp925f9gtXKMnYBJsYmtrkF9b+vciHBpLt3tE/oVNVxmTqH4oW6kuwtwa5rRSMHLmwlaR+nErq3928v5zTrCJZRsqZmyGgVr6t7RuoxM4NDRTkXKkNO+wTwCfBESLRzuvQ4B59zeOJISJ3HkD5DPjGMyHKP8loQnLadamBItOFgkKFc1DbG4aMo5MSZo5TUR0NC2SEzulYcMS21iRtqviPkaGbRI/djPIaWZBPwEIfDecoxXuBFMOaKhAhepdlmKIVCreAuj+/JnOB8q4v65KOBSpEpJByUNmagHJiRkTKP8oBDUVsn0h4xrRwoN+NBSPBG6Vqshxyus9p6sl8v6SNP9GAi+bQY5sU3wYOp3P1mo2U6g77cG1/uKUM+Ma5yTyjrdLzGVe1H+9eCpC4TMpz5YOfZABfhrujCGXw2gjNU2YoaUG5kR5Lg1Ia6aYepWSwwrTg1PXLQubtXko5g3R54kczgkGrlUEpLIft4+ZdWzoIx1C1Xyz9BNuAEo8vV8g8jqFyuLFUWWTAivX/Uu9HwM3g92IoTeN5n9lwQrE/ZDF7r26tLouA+yKYh+LhnLDsNbS4cIFtRBrHSraHVWLQviJMHCOTAamO1iSstpj404X22qIXkIBxytEK5yHJ5bvj5mGtGtAn1BoZLUjihVTzXZxG84K1dALWwegokukM2p1y3k+jb+7dfJXBBF99z3YCJF5fHj+HSFNtNtO57gqOMbWn1u7H4csZna4QyJxpA1z5v719fQGAcBYJg20c5NB/Fbs087zl6th4frXcbYVYVdNeTTHXssH+O/E2NoKgyYC3wn0tnalj+s/rfzK+HwA1twXy0TbFqbN9nBB/z/Kj1F7f6ncoPppMZAIWkUIdHz50pm+iVhKkU6+Crlv9dOL733W23tpL2YJBWcAs/mke9MRUlKrF14OJUs9qiRliRSBh07aRQEIdVt7BaCr749CW2J6hFQnCYWRrwj89BOk0tuBhNNsH531DLfbdR939DMNkTO1JoWx5PPppuFfzyeqn/F3uxidp8CAAA"
const rootStyles = "atm_9s_1txwivl atm_cx_1l7b3ar atm_lo_1l7b3ar atm_le_1l7b3ar atm_lk_1l7b3ar atm_ll_1l7b3ar atm_5j_1fwxnve atm_2d_trqlla";
const segmentStyles = "atm_am_40d212 atm_jb_idpfg4 atm_9s_1txwivl atm_h_1h6ojuz atm_fc_1h6ojuz atm_e2_14noui3 atm_lo_idpfg4 atm_le_idpfg4 atm_lk_1y44olf atm_ll_1y44olf atm_3f_idpfg4 atm_5j_ftgil2 atm_2d_1j28jx2 atm_7l_1fs2ovw atm_bx_1owkdjb atm_c8_1fwxnve atm_cs_1fw03zg atm_vv_1q9ccgz atm_9j_tlke0l atm_r2_1j28jx2 atm_uc_or2o4e atm_1s473yy_17gc6ap atm_1i1170i_1sy7hev atm_gpja8y_gnxck9 atm_1nvsyyg_1qhhqoo atm_18rmv75_2fli30 atm_17yrrpa_nbsu0t atm_6zeuib_12gsa0d";
const miniSegmentStyles = "atm_e2_1ul9x4n atm_c8_josmqz";
interface SegmentedOption<T> {
  'data-testid'?: string;
  label: string;
  value: T;
}
interface SegmentedControlProps<T> {
  'aria-label'?: string;
  className?: string;
  'data-testid'?: string;
  mini?: boolean;
  onChange(value: T): void;
  options: Array<SegmentedOption<T>>;
  value: T;
}
const SegmentedControl = <T extends string | number,>(props: SegmentedControlProps<T>) => {
  const {
    className,
    mini = false,
    onChange,
    options,
    value,
    'aria-label': ariaLabel,
    'data-testid': dataTestId
  } = props;
  return <div role="group" aria-label={ariaLabel} className={cx(rootStyles, className)} data-testid={dataTestId}>
            {options.map(option => <button key={String(option.value)} type="button" aria-pressed={option.value === value} className={cx(segmentStyles, mini && miniSegmentStyles)} data-testid={option['data-testid']} onClick={() => onChange(option.value)}>
                    {option.label}
                </button>)}
        </div>;
};
export default SegmentedControl;